# copy from https://github.com/TheSharpieOne/angular-input-match
MatchValidateDirective = ->
  require: 'ngModel'
  restrict: 'A'
  scope:
    matchValidate: '=gnpMatchValidate'
  link: (scope, elem, attrs, ctrl) ->
    scope.$watch ->
      (ctrl.$pristine and angular.isUndefined(ctrl.$modelValue)) or (scope.matchValidate is ctrl.$modelValue)
    , (currentValue) ->
      ctrl.$setValidity('matchValidate', currentValue)

module.exports = MatchValidateDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/match-validate-directive.coffee